import { render, staticRenderFns } from "./amendments-item.vue?vue&type=template&id=12a155ae"
import script from "./amendments-item.vue?vue&type=script&lang=js"
export * from "./amendments-item.vue?vue&type=script&lang=js"
import style0 from "./amendments-item.vue?vue&type=style&index=0&id=12a155ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports